import React from 'react';
import marked from 'marked';

const Header = ({ content }) =>
  content && content.content ? (
    <div
      className="Header"
      dangerouslySetInnerHTML={{
        __html: marked(content.content),
      }}
    />
  ) : null;

export default Header;
